module.exports = __webpack_public_path__ + "assets/img/circle_red.svg";